import companiesActions from '../actionTypes/companiesActions';

const initialState = {
  isLoading: true,
  openModal: false,
  isSubmitting: false,
  activeModalId: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case companiesActions.toggleCompanyForm:
      return {
        ...state,
        activeModalId: action.payload,
        openModal: !state.openModal,
      };
    case companiesActions.addNewCompany:
    case companiesActions.updateCompanyDetails:
      return { ...state, isSubmitting: true };
    case companiesActions.addNewCompanySuccess:
    case companiesActions.updateCompanyDetailsSuccess:
      return {
        ...state,
        ...action.payload,
        isSubmitting: false,
        errors: null,
        openModal: false,
      };
    case companiesActions.addNewCompanyFailed:
    case companiesActions.updateCompanyDetailsFailed:
      return { ...state, ...action.payload, isSubmitting: false };
    case companiesActions.resetToInitialState:
      return initialState;
    default:
      return state;
  }
};
